import React from 'react';
import { useTheme } from 'styled-components';
import { PaletteColorType } from '../../../theme/type/palette-type';
import { getOpacity } from '../../../theme/utils/get-rgb';

interface BadgePropsInterface {
    children: React.ReactNode;
    variant?: PaletteColorType;
    size?: 'small' | 'medium' | 'large';
    square?: boolean;
}

export const Badge: React.FC<BadgePropsInterface> = ({
    children,
    variant = 'default',
    size = 'medium',
    square,
}: BadgePropsInterface) => {
    const theme = useTheme();

    let sizeStyle: React.CSSProperties;

    if (size === 'small') {
        sizeStyle = {
            fontSize: '1rem',
            lineHeight: '1.6rem',
            minWidth: '1.6rem',
            padding: '0.1rem 0.7rem',
        };
    } else if (size === 'large') {
        sizeStyle = {
            fontSize: theme.text.size.small.fontSize,
            lineHeight: theme.text.size.small.lineHeight,
            minWidth: '1.9rem',
            padding: '0.3rem 1rem',
        };
    } else {
        sizeStyle = {
            fontSize: theme.text.size.xsmall.fontSize,
            lineHeight: theme.text.size.xsmall.lineHeight,
            minWidth: '1.9rem',
            padding: '0.2rem 1rem',
        };
    }

    return (
        <span
            className="inline-flex items-center justify-center font-bold not-italic uppercase"
            style={{
                borderRadius: square ? theme.radius.small : '10rem',
                color: theme.palette.color[variant].main,
                backgroundColor: getOpacity(theme.palette.color[variant].main, 0.1),
                transition: `all ${theme.base.transition}`,
                ...sizeStyle,
            }}
        >
            {children}
        </span>
    );
};
